module.exports = __webpack_public_path__ + "static/media/spectre.a7c36843.svg";